import { QueryErrorResetBoundary, useQueryClient } from '@tanstack/react-query';
import { ErrorInfo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useMatch } from 'react-router-dom';
import { ContentErrorFallback } from '../../components/ErrorFallback/ContentErrorFallback';
import { useLogger } from '../../context/useLogger';
import { logError } from '../../utils/logHelper';
import { DsnListErrorFallback } from '../../pages/dsn-list/component/DsnListErrorFallback';
import { AppRoutes } from '../../types/appRoutes';

// Niveau 3 : contenu des flux (DsnList, DsnDetails, etc.) — invalide les queries de données
export function PrivateNavBarErrorBoundary({
  children,
  errorLayout,
}: Readonly<{ children: React.ReactNode; errorLayout: string }>) {
  const logger = useLogger();
  const queryClient = useQueryClient();
  const isDsnList = useMatch({ path: AppRoutes.routeDsnList, end: true }) !== null;

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          FallbackComponent={isDsnList ? DsnListErrorFallback : ContentErrorFallback}
          onError={(error: unknown, info: ErrorInfo) => {
            const fallBackError =
              error instanceof Error ? error : new Error(`Unknown error on ${errorLayout}`);
            logError(logger, fallBackError, info);
          }}
          onReset={() => {
            reset();
            void queryClient.invalidateQueries({ queryKey: ['query-get', 'Dsns'] });
            void queryClient.invalidateQueries({ queryKey: ['query-get', 'DsnDetails'] });
            logger.info(`ErrorBoundary reset - ${errorLayout}`);
          }}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
